var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#D27F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9629 14.6657C31.3286 14.3228 30.5572 14.3571 29.9486 14.7514L26.6144 16.9371V15.0857C26.6144 13.38 25.2344 12 23.5286 12H12.0857C10.3886 12 9 13.38 9 15.0857V25.5256C9 27.2313 10.3886 28.6113 12.0857 28.6113H23.5286C25.2344 28.6113 26.6144 27.2313 26.6144 25.5256V23.6741L29.9486 25.8599C30.5572 26.2542 31.3286 26.2884 31.9629 25.9456C32.6057 25.6027 33 24.9342 33 24.2056V16.4054C33 15.6769 32.6057 15.0086 31.9629 14.6657ZM21.5057 21.7886L16.6799 24.5743C16.4142 24.7286 16.1228 24.8057 15.8228 24.8057C15.5314 24.8057 15.2314 24.7286 14.9657 24.5743C14.4342 24.2657 14.1085 23.7086 14.1085 23.0914V17.5201C14.1085 16.903 14.4342 16.3459 14.9657 16.0373C15.2399 15.883 15.5314 15.8059 15.8228 15.8059C16.1228 15.8059 16.4142 15.883 16.6799 16.0373L21.5057 18.8229C22.0372 19.1315 22.3629 19.6886 22.3629 20.3058C22.3629 20.9229 22.0372 21.4801 21.5057 21.7886Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8228 23.0913L20.6485 20.3057L15.8228 17.52V23.0913Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.e88f4f49.svg";
export { ForwardRef as ReactComponent };